import { HttpClient, HttpParams, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { GetBannerParams, GetBannerResponse } from "../models/banner-interface";
import { retry, timer, throwError } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class BannerApiService {
  apiUrl!: string;
  apiV!: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = environment.apiURL;
    this.apiV = environment.version;
  }

  fetchBanners(paramsObj: GetBannerParams = {}){
    let params = new HttpParams();
    params = params.append('PageIndex', (paramsObj.pageIndex ?? 0).toString());
    params = params.append('PageSize', (paramsObj.pageSize ?? 20).toString());
    if (paramsObj.sorts) params = params.append('Sorts', paramsObj.sorts);
    if (paramsObj.search) params = params.append('Search', paramsObj.search);
    if (paramsObj.searchFields && paramsObj.searchFields.length) {
      paramsObj.searchFields.forEach(f => params = params.append('SearchFields', f));
    }

    return this.httpClient.get<GetBannerResponse>(
      this.apiUrl + `/api/${this.apiV}/Banner`,
      { params: params }
    ).pipe(
      retry({
        count: 3, // Thử lại tối đa 3 lần
        delay: (error: HttpErrorResponse, retryCount: number) => {
          // Khi bị CORS do Nginx trả về 503 cho OPTIONS request, Angular sẽ nhận status = 0
          // Hoặc đôi khi trình chặn quảng cáo chặn cũng trả về status 0.
          if (error.status === 503 || error.status === 0) {
            console.warn(`[Banner API] Lỗi mạng/CORS (Status: ${error.status}), đang thử lại lần ${retryCount}...`);
            return timer(retryCount * 1000); // Thử lại sau 1s, 2s, 3s
          }
          return throwError(() => error);
        }
      })
    );
  }
}
